module.exports = {
      id: "ic-position-bottom-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-position-bottom-usage",
      toString: function () {
        return this.url;
      }
    }